import { FC, useEffect, useState } from 'react';

import dynamic from 'next/dynamic';
import moment from 'moment';
import styled from 'styled-components';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

import { DateType, formatMomentDate } from '@utils/dateUtil';

import {
  Arrow,
  ErrorMessage,
  ErrorMessageContainer,
} from '../carRentalAutoComplate/styled';

export const SearchBarDateInputWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.white};
  border-bottom: 1px solid #000;

  @media (min-width: ${({ theme }) => theme.breakPoint.TABLET}) {
    border-bottom: 0px solid #000;
  }
`;

const SearchBarSingleDatePicker = dynamic(
  () =>
    import(
      '@domain/carRental/searchBar/home/dateSelection/dateSelect/desktopDateSelect'
    ).then((mod: any) => mod['SearchBarSingleDatePicker']) as Promise<
      React.FC<any>
    >
);

const ResponsiveSingleDateSelect = dynamic(
  () =>
    import(
      '@components/views/flight/listing/SearchBar/DateSelect/ResponsiveSingleDateSelect'
    )
);

export interface IDateSelection {
  title: string;
  setDate: (value: moment.Moment) => void;
  date: moment.Moment;
  startDate?: DateType | null;
  endDate?: DateType | null;
  initialDate?: DateType | null;
  isOutsideRange?: (day: moment.Moment) => boolean;
}

const DateSelection: FC<IDateSelection> = ({
  title,
  initialDate,
  isOutsideRange,
  setDate,
  date,
}) => {
  const screen = useBreakpoint();

  const [isTouched, setIsTouched] = useState(false);
  const [error, setError] = useState(false);
  const [localDate, setLocalDate] = useState<DateType | null>(
    initialDate || null
  );

  useEffect(() => {
    setLocalDate(date);
  }, [date]);

  const onDateChange = (date: moment.Moment | null) => {
    setLocalDate(date);
    setDate(date as moment.Moment);
  };

  useEffect(() => {
    if (localDate) {
      setError(false);
      setIsTouched(true);
    } else {
      setError(true);
    }
  }, [localDate]);

  return (
    <SearchBarDateInputWrapper className='is-bordered'>
      {screen.xl || screen.md ? (
        <SearchBarSingleDatePicker
          label={title}
          onDateChange={onDateChange}
          date={localDate}
          inputComponent='shopAndFlyHomePageCarRental'
          error={(error && isTouched) as boolean}
          isOutsideRange={isOutsideRange}
        />
      ) : screen.xs ? (
        <ResponsiveSingleDateSelect
          date={localDate}
          onDateChange={onDateChange}
          title={title}
          subTitle={`${formatMomentDate(localDate)}`}
          placeholder={title}
          drawerTitle='Tarih Arama'
          arrowIcon={true}
          inputComponent='shopAndFlyHomePageCarRental'
          error={(error && isTouched) as boolean}
          isOutsideRange={isOutsideRange}
        />
      ) : null}
      {error && (
        <ErrorMessageContainer>
          <Arrow />
          <ErrorMessage>Tarih seçiniz</ErrorMessage>
        </ErrorMessageContainer>
      )}
    </SearchBarDateInputWrapper>
  );
};
export default DateSelection;
